/* Custom (Hundepappa): «Fast levering» i handlekurven + antallsvelger-oppførsel.
   1) Utvider cart-items med updateSellingPlan() og registrerer cart-selling-plan-button.
   2) Minus på 1 stk fjerner varelinjen (temaet ville ellers vist «minimum 1»-feil).
      «Fjern»-lenken er tatt bort fra draweren, så dette er eneste vei ut. */
(function () {
  customElements.whenDefined('cart-items').then(() => {
    const CartItems = customElements.get('cart-items');
    if (CartItems.prototype.updateSellingPlan) return;

    CartItems.prototype.updateSellingPlan = function (line, key, quantity, sellingPlanId) {
      this.enableLoading(key);

      this.updateAbortController?.abort();
      this.updateAbortController = new AbortController();

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      // Med selling_plan må linjen identifiseres med `line` (1-basert), ikke `id`.
      const body = JSON.stringify({
        line: parseInt(line, 10),
        quantity: parseInt(quantity, 10) || 1,
        selling_plan: sellingPlanId ? parseInt(sellingPlanId, 10) : null,
        sections: sectionsToBundle
      });

      fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body }, signal: this.updateAbortController.signal })
        .then((response) => response.json())
        .then((parsedState) => {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState, line: key });
        })
        .catch((error) => {
          if (error.name !== 'AbortError') console.error(error);
        });
    };
  });

  if (!customElements.get('cart-selling-plan-button')) {
    customElements.define(
      'cart-selling-plan-button',
      class CartSellingPlanButton extends HTMLButtonElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        onClick(event) {
          event.preventDefault();

          const cartItems = this.closest('cart-items');
          if (!cartItems || typeof cartItems.updateSellingPlan !== 'function') return;

          cartItems.updateSellingPlan(
            this.getAttribute('data-line'),
            this.getAttribute('data-index'),
            this.getAttribute('data-quantity'),
            this.getAttribute('data-selling-plan')
          );
        }
      }, { extends: 'button' }
    );
  }

  // Fanges i capture-fasen slik at temaets egen klikkhandler på knappen aldri kjører.
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const button = target.closest('#CartDrawer .quantity__button[name="minus"]');
    if (!button) return;

    const cartItems = button.closest('cart-items');
    const input = button.closest('.cart-quantity')?.querySelector('.quantity__input');
    if (!cartItems || !input || input.disabled) return;
    if (parseInt(input.value, 10) > 1) return;

    event.preventDefault();
    event.stopPropagation();

    cartItems.updateQuantity(input.getAttribute('data-index'), 0);
  }, true);
})();
